import mammoth from 'mammoth';

export async function extractDocxText(file) {
  const isDocx = file.type === 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    || file.name.toLowerCase().endsWith('.docx');

  if (!isDocx) {
    throw new Error('Please select a .docx Word document.');
  }

  const arrayBuffer = await file.arrayBuffer();
  const result = await mammoth.extractRawText({ arrayBuffer });
  const text = (result?.value || '').trim();

  if (!text) {
    throw new Error('No readable text found in the selected Word document.');
  }

  return text;
}
